export default "__VITE_ASSET__BmCcUf8h__"